<template>
  <div class="board-content-td activeCardHover" :class="dateReminder()" >
    <div v-show="dataset.unread_message_count > 0" class="task-badge"></div>
    <div class="board-top">
      <div class="task-title-wrap">
        <div class="task-title-wrap-item">
          <div @click.stop class="task-check">
            <el-checkbox v-model="check" :disabled="isArch || isCheckStatus || !dataset.edit_permission || isDisabledProject"></el-checkbox>
          </div>
          <toolTip style="width: 100%" :title="dataset.task_name">
            <span class="task-title" :title="dataset.task_name">{{ dataset.task_name }}</span>
          </toolTip>
        </div>
        <Myavatar width="28px" v-if="dataset && dataset.executor_user" height="28px" :imgUrl="dataset.executor_user.user_avatar" :userName="dataset.executor_user.realname"></Myavatar>
      </div>
      <div class="task-create-date">
        <div class="task-flex-box">
          <div class="task-left">
            <div class="task-left-item" v-if="dataset.all_children_task_count > 0">
              <i class="icon iconfont iconicon_subtasks2"></i>
              <div class="task-sub-info">
                <span class="finish_num">{{ lost99(dataset.finish_children_task_count) }}</span>
                <span class="slash">/</span>
                <span class="total_num">{{ lost99(dataset.all_children_task_count) }}</span>
              </div>
            </div>
            <div class="task-left-item" v-if="dataset.association_dependency_count > 0">
              <i class="icon iconfont iconicon_associated_tasks"></i>
              <span>{{ lost99(dataset.association_dependency_count) }}</span>
            </div>
            <div class="task-left-item" v-if="getFileCount() > 0">
              <i class="icon iconfont iconicon_annex2"></i>
              <span>{{ lost99(getFileCount()) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="board-bottom">
      <div class="task-principal">
        <div class="avatar-wrap">
          <span v-if="dataset.end_time" class="task-date">{{ dataset.end_time.replace(/-/g, "/") }}</span>
          <!-- <div class="task-level" :style="{ color: itemLevelStyle(dataset.sort_rule.sort).color, 'background-color': itemLevelStyle(dataset.sort_rule.sort).bgColor }">{{ itemLevelStyle(dataset.sort_rule.sort).otherName }}</div> -->
          <TaskLevel :level="dataset.sort_rule.sort"></TaskLevel>
          <FollowTask class="board-start" :show="dataset.is_attention"></FollowTask>
          <!-- <span class="task-date" v-if="!dataset.end_time">日期暂无设定</span> -->
        </div>
        <div class="task-sn">
          <div class="task-sn-nore" @click="stopde" :class="{'visibleActive': show}" v-if="!isCheckStatus && !isDisabledProject">
            <el-dropdown @command="handleCommand" v-model="show" size="small" trigger="click"  @visible-change="changeListShow">
              <span class="task-sn-hover">
                <i class="icon iconfont iconicon_more_task1 tableIconHover"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="task-drop-item" :command="{ type: 'archive', dataset }" v-if="dataset.archive_permission"><i class="icon iconfont iconicon_move"></i>归档</el-dropdown-item>
                <el-dropdown-item class="task-drop-item" :command="{ type: 'unarchive', dataset }" v-if="dataset.activate_archived_tasks_permission"><i class="icon iconfont iconicon_restore"></i>恢复未归档</el-dropdown-item>
                <el-dropdown-item class="task-drop-item" :command="{ type: 'unFollow', dataset }" v-if="dataset.is_attention"><i class="icon iconfont iconicon_following"></i>取消关注</el-dropdown-item>
                <el-dropdown-item class="task-drop-item" :command="{ type: 'follow', dataset }" v-else><i class="icon iconfont iconicon_focus_on"></i>关注</el-dropdown-item>
                <el-dropdown-item class="task-drop-item border" :command="{ type: 'del', dataset }" v-if="dataset.delete_permission"><i class="icon iconfont iconicon_recycle_bin"></i>移至回收站</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="mask-check" v-if="isCheckStatus" :class="{'check': hasCheck}"></div>
  </div>
</template>
<script>
import { dateReminder } from "@/utils";
import TaskLevel from '@/components/taskLevel'
import api from "@/services/api/task/task";
import { mapState } from 'vuex';
export default {
  props: {
    dataset: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: null
    }
  },
  components: {
    TaskLevel
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapState('task/task', {
      isCheckStatus: state => state.isCheckStatus,
      checkTask: state => state.checkTask,
      isDisabledProject: state => state.isDisabledProject
    }),
    check: {
      get: function () {
        return this.dataset.task_stage === '已完成' || this.dataset.before_archiving_is_completed
      },
      set: function (newValue) {
        console.log(newValue)
        if(newValue) {
          this.dataset.task_stage = '已完成'
        } else {
          this.dataset.task_stage = '进行中'
        }
        this.taskStatusChange()
      }
    },
    isArch() {
      return this.dataset.task_stage === '已归档'
    },
    hasCheck() {
      let fl = this.checkTask.indexOf(this.dataset.id) > -1
      this.$set(this.dataset, 'check', fl)
      return fl
    }
  },
  methods: {
    dateReminder() {
      let result = dateReminder(this.dataset)
      if(this.isArch) {
        return 'complete'
      } else if(result === 'complete') {
        return 'children-row complete-time complete-task'
      }else if (!this.dataset.end_time) {
        return "complete-time"
      } else if (result === "expired") {
        return "children-row complete-time expired"
      } else if (result === "remind") {
        return "children-row complete-time remind"
      } else {
        return "children-row complete-time"
      }
    },
    getFileCount() {
      return this.dataset.template.template_standard_components.reduce((pre, item) => {
        if (item.component_code === "TaskComponent.Attachment.Attachment") {
          return pre + item.component_values.length;
        } else {
          return pre;
        }
      }, 0);
    },
    stopde(e) {
      e.stopPropagation();
    },
    handleCommand(comm) {
      this.$emit('handleCommand', comm)
    },
    lost99(num) {
      return num * 1 > 99 ? "99+" : Number(num);
    },
    changeListShow() {
      this.show = !this.show
    },
    async taskStatusChange() {
      await api.updateTaskStage({ task_id: this.dataset.id, task_stage: this.dataset.task_stage })
      this.$emit('changeCheck', this.index)
    },
  }
}
</script>
<style lang="scss">
  .board-content-td {
    .mask-check {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      border-radius: 4px;
      border: 1px solid transparent;
    }
    .check {
      border: 1px solid #2682FF;
      background: rgba(38,130,255,0.08);
    }
  }
</style>
